import { useEffect } from "react"
import { useHistory } from "react-router-dom";
import { getSession, valdiatePage } from "../global";

const OldPortal = () => {
    const history = useHistory();

    useEffect(() => {
        if (valdiatePage('/oldportal')) {
            const u = getSession('userInfo');
            const id = btoa(u.id.toString());
            window.open(`http://mnpcourier.com/mycod/Login_new.aspx?i=${id}`);
        } else {
            history.push('/login');
        }
    }, [])

    return <section className="section">
        <div className="section-header">
            <h1>Old Portal</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-12">
                </div>
            </div>
        </div>
    </section>
}

export default OldPortal;